<template>
	<a-dialog class="survey">
		<question
			ref="question"
			:question="loadQuestion"
			:category="loadCategory"
			:category-index="categoryIndex"
			:number="currentQuestion"
			:total="totalQuestions"
			:selected="getQuestionAnswers"
			@input="setQuestionAnswers"
		/>
		<template v-if="!error" slot="actions">
			<p class="survey__more-answers">
				{{ $t("moreAnswers") }}
			</p>
			<a-button v-if="category || question" class="survey__prev_btn" secondary @click="previous">
				{{ $t("previous") }}
			</a-button>
			<a-button :disabled="nextDisabled" :to="nextTarget()" class="survey__next_btn">
				{{ $t("next") }}
			</a-button>
		</template>
	</a-dialog>
</template>

<script>
import Question from "@/components/Question";
import ADialog from "@/components/Dialog";
import aButton from "@/components/Button";
import survey from "../survey";
import RouterGuards from "../mixins/RouterGuards";

export default {
	components: {
		Question,
		ADialog,
		aButton,
	},
	mixins: [RouterGuards],
	props: {
		category: { type: Number, default: 0 },
		question: { type: Number, default: 0 },
	},
	i18n: {
		messages: {
			en: {
				previous: "Previous",
				next: "Next",
				moreAnswers: "*You are able to mark multiple answers.",
			},
			nl: {
				previous: "Vorige",
				next: "Volgende",
				moreAnswers: "*Je kunt meerdere antwoorden aanvinken.",
			},
		},
	},
	data() {
		return {
			selectedAnswers: survey.answers || {},
			activeCategory: 0,
			activeQuestion: 0,
		};
	},
	computed: {
		error() {
			return survey.error;
		},
		categories() {
			return survey.categories;
		},
		categoryIndex() {
			return this.category;
		},
		loadCategory() {
			return this.categories[this.category];
		},
		loadQuestion() {
			return this.loadCategory.questions[this.question];
		},
		getQuestionAnswers() {
			return this.selectedAnswers[this.loadQuestion.id];
		},
		nextDisabled() {
			return this.getQuestionAnswers === undefined;
		},
		currentQuestion() {
			let count = 1;
			for (let i = 0; i < this.category; i++) {
				count += this.categories[i].questions.length;
			}
			return count + this.question;
		},
		totalQuestions() {
			return this.categories.reduce((total, value) => total + value.questions.length, 0);
		},
	},
	watch: {
		category: {
			immediate: true,
			handler(val) {
				this.$emit("setHeader", val + 1);
			},
		},
		categories: {
			immediate: true,
			handler(val) {
				const selectedClone = {};
				for (let categoryId = 0; categoryId < val.length; categoryId++) {
					for (let i = 0; i < val[categoryId].questions.length; i++) {
						const { id } = val[categoryId].questions[i];
						selectedClone[id] = this.selectedAnswers[id] || undefined;
					}
				}
				this.selectedAnswers = selectedClone;
			},
		},
	},
	methods: {
		setQuestionAnswers(val) {
			this.selectedAnswers[this.loadQuestion.id] = val;
		},
		nextTarget() {
			let nextQuestion = this.question + 1;
			let nextCategory = this.category;

			if (nextQuestion >= this.loadCategory.questions.length) {
				nextCategory++;
				if (nextCategory >= this.categories.length) {
					survey.answers = this.selectedAnswers; // Nefarious, refactor to store
					return { name: "summaryLoading" };
				}
				nextQuestion = 0;
			}
			return {
				name: "survey",
				query: { category: nextCategory, question: nextQuestion },
			};
		},
		previous() {
			if (!this.loadCategory || !this.loadQuestion) {
				this.$router.replace({
					name: "home",
				});
				return;
			}
			this.$router.go(-1);
		},
		reload() {
			window.location.reload();
		},
		focusNext() {
			this.$refs.question.focusFirstAnswer();
		},
	},

};
</script>

<style lang="scss">
.survey {
	max-width: 880px;
}
.survey__prev_btn {
	margin-right: 15px;
}
.survey__more-answers {
	flex: 1;
	line-height: 40px;
	margin: 0;
	font-size: 13px;
	color: $black;
}
@media only screen and (max-width: 767px) {
	.survey .dialog__actions {
		flex-wrap: wrap;
	}
	.survey__more-answers {
		flex: 1 0 100%;
	}
	.survey__prev_btn {
		flex: 1 0 30%;
	}
	.survey__next_btn {
		flex: 1 0 60%;
	}
	.survey__more-answers {
		margin-bottom: 10px;
	}
}
</style>
